'use strict';

const vex = require('vex-js');

module.exports = (video, options) => vex.open({
	unsafeContent: `
		<div class='content'>
			<div class='content__inner'>
				<iframe src='https://www.youtube.com/embed/${video}?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1&amp;color=white${options.timestamp && `&amp;start=${options.timestamp}`}' frameborder='0' style='width: 100%; height: 100%;' allowfullscreen></iframe>
			</div>
		</div>`,
	contentClassName: 'video'
});
